<div class="grid-container padding-y-4">
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <legend class="usa-legend usa-legend--large"> {{title}}</legend>
    </div>
  </div>
  <div >
    
      <ag-grid-angular
      class="ag-theme-alpine"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [columnDefs]="columnDefs"
      [suppressDragLeaveHidesColumns]="true"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>

   
  </div>

</div>

